import { render, staticRenderFns } from "./PurgeStats.vue?vue&type=template&id=51f8f023&"
import script from "./PurgeStats.vue?vue&type=script&lang=js&"
export * from "./PurgeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports